// @flow
import createMessages from 'mz-intl/create'

const MESSAGES = {
  OK: 'OK',
  CLOSE: 'Close',
  SET: 'Set',
  SAVE: 'Save',
  SELECT: 'Select',
  EDIT: 'Edit',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  REQUIRED: 'Required',
}

export default createMessages<typeof MESSAGES>('UIKIT_COMMONS', MESSAGES)
